module.exports = __webpack_public_path__ + "static/media/scan-luxtrust@2x.fc4cac94.png";